import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";

export default function FAQTeaser() {
  return (
    <section className="py-16 bg-background" aria-labelledby="faq-teaser-heading">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="bg-brand-navy rounded-2xl px-8 py-10 sm:px-12 flex flex-col sm:flex-row items-start sm:items-center gap-6 justify-between">
          <div className="flex items-start gap-4">
            <div className="w-11 h-11 rounded-[10px] bg-white/10 flex items-center justify-center shrink-0">
              <ShieldCheck className="w-5 h-5 text-brand-teallight" />
            </div>
            <div>
              <h2 id="faq-teaser-heading" className="text-xl sm:text-2xl font-extrabold text-white tracking-tight">
                Governance &amp; Trust FAQ
              </h2>
              <p className="mt-2 text-sm text-white/70 max-w-xl leading-relaxed">
                Regulatory accuracy, AI validation, audit trails, data integrity, and security —
                the questions QA leads and IT teams ask before trusting a compliance platform, answered with evidence.
              </p>
            </div>
          </div>
          <Link
            to="/governance-faq"
            className="inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-brand-teal hover:bg-brand-teal/90 text-white text-sm font-semibold transition-colors shrink-0"
          >
            Read the FAQ <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}